import React from "react";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./features.module.scss";

export const UniPageAnalyticsFeatures = () => {
  const data = [
    {
      id: 1,
      title: "Direct Student Profile Access",
      content:
        "Select, shortlist and engage prospective applicants through direct access to the profiles of your best-fit students",
      icon: getAssets("assets/icons/university/student_profile.svg"),
      color: "red",
    },
    {
      id: 2,
      title: "Chat in Real-Time",
      content:
        "Respond to student queries and follow up on applications in real-time through intuitive chat features",
      icon: getAssets("assets/icons/university/chat.svg"),
      color: "violet",
    },
    {
      id: 3,
      title: "Receive and Track Applications",
      content:
        "Know at a glance how many prospects are converting daily into active applicants and when to follow up to boost application completion rates",
      icon: getAssets("assets/icons/university/checklist.svg"),
      color: "green",
    },
    // {
    //   id: 4,
    //   title: "View Real-Time Market Analytics",
    //   content:
    //     "Get an in-depth look at the engagement behaviours and patterns of audiences in your target markets to inform localised recruitment strategies",
    //   icon: getAssets("assets/icons/university/time.svg"),
    //   color: "orange",
    // },
    {
      id: 5,
      title: "Manage Your University and Course Profiles",
      content:
        "Ensure your prospects are always up-to-date with what you are offering by adding, removing, or editing pertinent information on profile and course pages",
      icon: getAssets("assets/icons/university/school.svg"),
      color: "red",
    },
    {
      id: 6,
      title: "Set Your University’s Distinct Voice Apart",
      content:
        "Curate rich media content, including blogs, videos, images, and more, to engage your best-fit prospects, establish your brand voice, and enrich student experiences with your university",
      icon: getAssets("assets/icons/university/audio_book.svg"),
      color: "pink",
    },
    {
      id: 7,
      title: "Participate in Global Virtual Fairs",
      content:
        "Enjoy unique opportunities to engage with students in distinct locales around the world one-to-one through UniSearch-hosted virtual fairs",
      icon: getAssets("assets/icons/university/globalization.svg"),
      color: "green",
    },
    {
      id: 8,
      title: "Collaborate with UniSearch Counsellors",
      content:
        "Connect instantly with a dedicated team of regional experts to coordinate and optimise recruitment efforts and collaboration opportunities with local institutions",
      icon: getAssets("assets/icons/university/operator.svg"),
      color: "orange",
    },
    {
      id: 9,
      title: "Host Events Across the World",
      content:
        "Enhance your access to diverse markets around the world by hosting virtual events through UniSearch",
      icon: getAssets("assets/icons/university/appointment.svg"),
      color: "violet",
    },
  ];

  return (
    <section>
      <div className="container">
        <div className={styles.features_wrapper}>
          {data.map((item, i) => {
            return (
              <div
                className={`${styles.feature_card} ${styles[item.color]}`}
                key={item.id}
              >
                <div className={styles.feature_card_icon}>
                  <ReactSVG src={item.icon} />
                </div>
                <div className={styles.feature_card_content}>
                  <h3 className={styles.feature_card_title}>{item.title}</h3>
                  <p className={styles.feature_card_text}>{item.content}</p>
                </div>
              </div>
            );
          })}

          {/* end */}
        </div>
      </div>
    </section>
  );
};

export default UniPageAnalyticsFeatures;
